<div nz-row class="passport-frame">
  <div nz-col [nzFlex]="leftWidth" class="login-part">
    <ng-container *ngIf="WorkersData.XencioIcon === 'show'; else NoImgTemplate">
      <img
        class="mb-xxl"
        [src]="'assets/img/logo-color' + (WorkersData.openBy === 'Xencio' ? '' : '-' + WorkersData.openBy) + '.png'"
        width="320"
      />
    </ng-container>

    <ng-template #NoImgTemplate>
      <div class="mb-xxl" style="height: 64px"></div>
    </ng-template>

    <router-outlet></router-outlet>
  </div>

  <div nz-col nzFlex="auto" class="image">
    <div class="title">
      <div class="subtitle">ㅤ</div>
      <ng-container i18n>Aldi奥乐齐资金管理系统</ng-container>
    </div>

    <div class="official">
      <div nz-row nzAlign="middle" nzGutter="4">
        <div nz-col>沪ICP备15017441号</div>
        <div nz-col><img src="assets/img/passport/gov.png" /></div>
        <div nz-col>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402005986" target="_blank">
            沪公网安备 31010402005986号
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
